'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _synchronization = require('redux/modules/synchronization');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SchoolLevels = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    synchronizing: state.synchronization.synchronizing,
    report: state.synchronization.report
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SchoolLevels, _Component);

  function SchoolLevels() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SchoolLevels);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SchoolLevels.__proto__ || (0, _getPrototypeOf2.default)(SchoolLevels)).call.apply(_ref, [this].concat(args))), _this), _this.handleSynchronizeClick = function () {
      _this.props.dispatch((0, _synchronization.synchronize)());
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SchoolLevels, [{
    key: 'render',
    value: function render() {
      var styles = require('./Synchronization.scss');
      var _props = this.props,
          synchronizing = _props.synchronizing,
          report = _props.report;

      return _react2.default.createElement(
        'div',
        { className: styles.synchronization },
        _react2.default.createElement(
          'section',
          { className: styles.box },
          _react2.default.createElement(
            'h1',
            { className: styles.boxTitle },
            'Synchronisation'
          ),
          _react2.default.createElement('div', { className: styles.boxBar })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'section',
            { className: styles.box },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Les \xE9l\xE9ments suivants seront synchronis\xE9s entre prep.jai20enmaths.com et jai20enmaths.com :'
              ),
              _react2.default.createElement(
                'ul',
                { className: styles.elementsList },
                _react2.default.createElement(
                  'li',
                  null,
                  'Niveaux scolaires'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Chapitres'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Sections de documents'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Documents (fiches, vid\xE9os, etc.)'
                )
              )
            ),
            _react2.default.createElement(
              _reactLadda2.default,
              { className: styles.createLevelButton,
                'data-style': 'slide-down',
                loading: synchronizing, onClick: this.handleSynchronizeClick },
              'Synchroniser'
            ),
            report ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Synchronisation r\xE9ussie !'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Statistiques :',
                _react2.default.createElement(
                  'ul',
                  { className: styles.elementsList },
                  report.map(function (line) {
                    return _react2.default.createElement(
                      'li',
                      null,
                      line.name,
                      ' : ',
                      line.count
                    );
                  })
                )
              )
            ) : null
          )
        )
      );
    }
  }]);
  return SchoolLevels;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func.isRequired,
  synchronizing: _react.PropTypes.bool.isRequired,
  report: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = SchoolLevels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Synchronization/Synchronization.js
// module id = 1193
// module chunks = 0